/**
 * BI P2 Consent Mode v2:必須在 GTM 模組的 plugin(@zadigetvoltaire/nuxt-gtm,
 * 未指定 enforce,走預設順序)插入 GTM 腳本之前,把 default_consent(denied)
 * 推進 dataLayer——用 enforce:'pre' 而非依賴檔名/掃描順序來保證這件事。
 *
 * prod 的 GTM 已經開著、帶著既有 DG 再行銷 tag 在收資料,不能靠
 * runtimeConfig.public.gtm.enabled 當作「還沒設定」的判斷依據。改用獨立的
 * runtimeConfig.public.consentModeEnabled 暗旗標(預設 false):旗標關閉時
 * pushConsentDefault/applyStoredConsent 內部直接 no-op,不推任何 dataLayer
 * 事件,不影響既有收集。
 *
 * BI P2 follow-up:回訪且已同意的使用者,除了補推 consent update(granted),
 * 還要補推之前被 updateAnalyticsUserId() 擋下的 set_user_id——分析 cookie
 * (analyticsUserId)先於同意 cookie 讀出來的話,那次呼叫是在「尚未回應」狀態
 * 下被擋的,不會自己補推。
 */
export default defineNuxtPlugin({
  name: 'consent',
  enforce: 'pre',
  setup() {
    const consentModeEnabled = useRuntimeConfig().public.consentModeEnabled
    const { pushConsentDefault, getStoredConsentChoice, applyStoredConsent } = useConsent()

    pushConsentDefault(consentModeEnabled)

    const storedChoice = getStoredConsentChoice()
    if (storedChoice !== null) {
      applyStoredConsent(consentModeEnabled)
    }
    if (consentModeEnabled && storedChoice === 'granted') {
      useUserStore().flushAnalyticsUserId()
    }
  },
})
